import { useMemo, useState } from "react";
import SectionHeading from "./SectionHeading";
import { galleryWorks } from "@/mocks/doujinData";

const filterOptions = ["全部", "高清画集", "精选图包", "高清原图", "扫描本集"];

export default function Gallery() {
  const [active, setActive] = useState("全部");

  const filtered = useMemo(() => {
    if (active === "全部") return galleryWorks;
    return galleryWorks.filter((w) => w.cat === active);
  }, [active]);

  return (
    <section id="gallery" className="py-16 md:py-24 bg-background-50">
      <div className="container-x">
        <SectionHeading
          eyebrow="在线浏览"
          title="高清原图 · 画集 · 图包"
          desc="支持分类筛选，画质清晰、细节丰富，随时随地在线欣赏心仪的同人作品。"
        />

        <div className="flex flex-wrap items-center justify-center gap-2 mb-9">
          {filterOptions.map((opt) => (
            <button
              key={opt}
              type="button"
              onClick={() => setActive(opt)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                active === opt
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
              }`}
            >
              {opt}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {filtered.map((work) => (
            <div
              key={work.id}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200"
            >
              <div className="relative overflow-hidden">
                <img
                  src={work.image}
                  alt={`${work.title} - 同人本子${work.cat}高清浏览`}
                  className="w-full aspect-[3/4] object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                <button
                  type="button"
                  className="absolute bottom-3 right-3 px-3 py-1.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all whitespace-nowrap"
                >
                  <i className="ri-eye-line mr-1"></i>高清查看
                </button>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base text-foreground-950 line-clamp-1">
                  {work.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-600">作者：{work.author}</p>
                <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {work.views}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-heart-3-line text-primary-500"></i>
                    {work.likes}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}